/**
 * Depth-first flatten of the node tree, in the same order the nodes are rendered.
 * Grouped querylets live in `items`, so anything that reasons about "the next node"
 * (focus order, grouping targets) has to walk the whole tree, not just the top level.
 */
export function flattenNodeTree(nodesTree, collected = []) {
  (Array.isArray(nodesTree) ? nodesTree : []).forEach((node) => {
    if (!node) return;
    collected.push(node);
    flattenNodeTree(node.items, collected);
  });

  return collected;
}

export function findParentNode(nodesTree, nodeUuid) {
  const list = Array.isArray(nodesTree) ? nodesTree : [];

  const directParent = list.find((item) => Array.isArray(item?.items) && item?.items?.some((child) => child?.uuid === nodeUuid));
  if (directParent) {
    return directParent;
  }

  let nestedParent = null;
  list.some((item) => {
    nestedParent = findParentNode(item?.items, nodeUuid);
    return !!nestedParent;
  });

  return nestedParent;
}

export function findNodeSiblingsWithIndex(nodesTree, nodeUuid) {
  const list = Array.isArray(nodesTree) ? nodesTree : [];
  const directIndex = list.findIndex((item) => item?.uuid === nodeUuid);

  if (directIndex > -1) {
    return {
      siblings: list,
      index: directIndex,
    };
  }

  let nestedResult = null;
  list.some((item) => {
    if (!Array.isArray(item?.items) || item?.items?.length === 0) {
      return false;
    }

    nestedResult = findNodeSiblingsWithIndex(item.items, nodeUuid);
    return !!nestedResult;
  });

  if (nestedResult) {
    return nestedResult;
  }

  return null;
}
